"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback/AlertFeedback"));

var _CompletedContext = require("../CompletedContext");

var _DesignComponents = require("../DesignComponents/DesignComponents");

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));

require("./TaskRank.scss");

var TaskRank = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskRank, _Component);

  var _super = (0, _createSuper2.default)(TaskRank);

  function TaskRank(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskRank);
    _this = _super.call(this, props);
    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.value = [];
      _this.state.showModal = false;
    }

    _this.handleDropdownSelection = _this.handleDropdownSelection.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskRank, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "handleDropdownSelection",
    value: function handleDropdownSelection(e, index) {
      var tempArr = this.state.value.slice();
      console.log("BEFORE", tempArr);
      var srtext = ""; //

      var temp = undefined;
      var swapIndex = tempArr.indexOf(e.value);

      if (swapIndex !== -1) {
        var oldposition = swapIndex + 1;
        var newposition = index + 1;
        temp = tempArr[index];
        srtext = e.value + " was moved from Rank " + oldposition + " to Rank " + newposition;
      }

      if (temp) tempArr[swapIndex] = temp;
      tempArr[index] = e.value;
      console.log("AFTER", tempArr);
      this.setState({
        value: tempArr,
        srtext: srtext
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this3 = this;

      var correctSubmission = true;

      if (this.state.value.length === this.props.correct.length) {
        this.state.value.forEach(function (item, i) {
          if (_this3.state.value[i] !== _this3.props.correct[i]) correctSubmission = false;
        });
      } else {
        correctSubmission = false;
      }

      this.setState({
        correct: correctSubmission,
        completed: true,
        showModal: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task-rank"
      }, /*#__PURE__*/_react.default.createElement("p", {
        role: "alert",
        className: "sr-only"
      }, this.state.srtext, this.state.completed && "The ranking results are now available for the last column of the table"), /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
        tabIndex: "0"
      }, "Rank"), /*#__PURE__*/_react.default.createElement("th", {
        tabIndex: "0"
      }, "Your Choice"), this.state.completed && /*#__PURE__*/_react.default.createElement("th", {
        tabIndex: "0"
      }, this.props.correctHeader || "Correct")), this.props.options.map(function (value, index) {
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: value
        }, /*#__PURE__*/_react.default.createElement("td", {
          tabIndex: "0"
        }, _this4.props.rank[index]), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "sr-only"
        }, " ", _this4.props.rank[index], " "), /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown, {
          key: value + index,
          label: "Rank your choice:",
          disabled: _this4.state.completed,
          onChange: function onChange(e) {
            _this4.handleDropdownSelection(e, index);

            _this4.forceUpdate();
          },
          selected: _this4.state.value[index],
          buttonContents: _this4.state.value[index]
        }, _this4.props.options.map(function (value, index) {
          return /*#__PURE__*/_react.default.createElement(_DesignComponents.Dropdown.Option, {
            key: value + index,
            value: value
          }, value);
        }))), _this4.state.completed && /*#__PURE__*/_react.default.createElement("td", null, _this4.props.correct[index]));
      }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        className: "bdg-submit-button",
        type: "submit",
        disabled: this.state.completed,
        style: {
          margin: "30px 0px"
        },
        onClick: this.handleSubmit
      }, "Submit")), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        correct: this.state.correct,
        show: this.state.showModal,
        onHide: function onHide() {
          _this4.setState({
            showModal: false
          });
        },
        children: this.state.correct ? this.props.correctFeedback : this.props.incorrectFeedback
      }));
    }
  }]);
  return TaskRank;
}(_react.Component);

exports.default = TaskRank;
TaskRank.contextType = _CompletedContext.CompletedContext;